import {block, unblock} from './block-ui';
import {confirm} from './alerts';

/**
 * Add AJAX loading to some tabs based on bootstrap tabs
 */

let timerId = 0;
let times = 0;

const handle = function () {
    times++;

    if (times >= 10) {
        // Stop interval
        clearInterval(timerId);
        return;
    }

    if ($('#tabs_details-nav-ul .js-tab').length <= 0) {
        return false;
    }

    clearInterval(timerId);

    $('#tabs_details-nav-ul > LI').on('click', 'A', function (ev) {
        ev.preventDefault();

        tracker.track('Страница товара => Просмотр вкладки', {
            Вкладка: ev.target.innerText,
            Url: document.baseURI,
        });

        if ($(this).is('.js-tab-confirm') && !$(this).hasClass('is-confirmed')) {
            ev.stopPropagation();

            // With confirm
            confirm(
                $(this).data('confirm'),
                () => {
                    $(this).addClass('is-confirmed');

                    // Call that again
                    $(this).click();
                },
                () => {}
            );
        }
    });

    $('#tabs_details-nav-ul > LI').on('click', function (ev) {
        ev.preventDefault();

        const tab = $(this).find('.js-tab');

        if (tab.length < 1) {
            return;
        }

        const page = tab.attr('href').replace('#', '');
        const currentTab = $(`#tabs_details .tab-pane#${page}`);

        if (currentTab.length > 0 && currentTab.is('.js-loaded')) {
            // Already loaded before
            return;
        }

        const goodId = $('.js-page-good').data('id');
        block();

        $.post(`/good/${goodId}/get-tab/${page}/`, function (response) {
            unblock();

            currentTab.html(response).addClass('js-loaded');

            if (page === '3d') {
                import('./photo3d');
            }
        });
    });
};

if ($('#tabs_details').length > 0) {
    // Try to run it from first time
    if (handle() === false) {
        // Try again
        timerId = setInterval(handle, 500);
    }
}
